(ns frontend.view.modals.curtains.settings-curtain.view
  (:require [common.localization :as loc]
            [frontend.workaround :as wr]
            [reagent.core :as r]
            [ui.components.modal.view :as modal]
            [ui.components.toggle.view :as toggle]
            [ui.components.radio-group.view :as radio-group]))

(defonce modal-key :curtain/settings)

(defn view
  [{:keys [shown? topmost? close-modal! props state]}]
  (let [error-state (r/cursor state [:error-text])]
    (fn [{:keys [shown? topmost? close-modal! props state class-name]}] ;; modals generated state overridden with parameter on purpose
      (let [{:keys [header-text
                    options
                    state
                    fields-getter
                    label-row-width
                    values-row-width
                    boolean-mode?
                    on-save!
                    unsaved-changes?
                    on-change!]}
            props
            fields (when (and state fields-getter)
                     (fields-getter @state))
            opt-size (case (count options)
                       1 12
                       2 6
                       3 4
                       4 3
                       5 2
                       1)
            opt-size (if boolean-mode? 12 opt-size)
            close! (fn [_]
                     (when on-save!
                       (on-save!))
                     (close-modal!))]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :close-button? true}
         header-text
         [:<>
          (when @error-state
            [:div
             {:class "bg-danger-light"}
             (str @error-state)])

          [:form
           {:class "flex flex-col divide-y divide-solid divide-base-light-border-paler"}
           (when-not boolean-mode?
             [:div
              {:class "grid grid-cols-2 gap-2"}
              [:div
               {:class "col-span-2"}
               ""]
              [:div
               {:class "col-span-2"}
               [:div
                {:class "flex justify-end"}
                (doall (for [[opt-kw opt-name] options]
                         [:div
                          {:key        (str "select-curtain-header-" (name opt-kw))
                           :class "pb-2 w-20 flex justify-end"}
                          opt-name]))]]])
           (doall
            (for [field fields]
              [:div
               {:key        (str "select-curtain-row-" (wr/key->js-workaround (:field/key field)))
                :class "py-2.5 flex justify-between items-center"}
               [:div
                [:div
                 (:field/name field)]]
               [:div
                 {:class "flex items-center gap-3 *:gap-14"}
                 (if-not boolean-mode?
                   [radio-group/radio-group-v2
                    {:checked (:field/value field)
                     :orientation :horizontal
                     :on-change (fn [new-value]
                                   (on-change! (:field/key field) new-value))}
                    (->> [:in-use :not-used]
                         (map (fn [p]
                                {:value   p
                                 :content nil
                                 :disabled? (:field/disabled? field)})))]
                                   ;; for boolean mode:
                   (let [checked? (:field/value field)
                                         ;;if we wish to add a label for the switch in the future:
                         true-label (get options true)]
                     [:div
                      {:class "text-center"
                       :key        (str "select-curtain-" (:field/name field) "-switch")}
                      [toggle/toggle
                       {:checked?   checked?
                        :disabled?  (:field/disabled? field)
                        :on-change (fn [_] (on-change! (:field/key field) (not checked?)))}]]))]]))]]
         [:<>
          [modal/left-cancel-only close-modal! nil]
          [modal/right-single-button
           nil
           (and (fn? unsaved-changes?)
                (not (unsaved-changes?)))
           close!
           (loc/tr :save)
           nil]]]))))
